import axios from "../../axios";

const api = {
  createGeneralData({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.post(`/supplier-questionnaires/${questionnaireId}/general`, data, headers)
      .then(({ data }) => data);
  },

  updateGeneralData({ questionnaireId, id, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/general/${id}`, data, headers)
      .then(({ data }) => data);
  }
}

export default api;